<template>
  <div v-if="info" class="container-info-facility">
    <div class="info-all-facility info_1">
      <div class="route-facility d-flex align-items-center">
        <RouterLink class="mr-5 mb-1" to="/wap">
          <img style="width: 17px;" :src="bg.icon_home" alt="" />
        </RouterLink>
        /
        <RouterLink class=" mr-5 ml-5" to="/san-noi-bat">
          <span style="color: black;" class="c-caption text-uppercase">
            {{ $t("wap.text136") }}</span
          >
        </RouterLink>
        /
        <span
          style="color: black;"
          class="c-caption  ml-5 fw-600 text-uppercase"
        >
          {{ $t("yardDetails") }}</span
        >
      </div>
      <div
        class="d-flex flex-wrap mt-10 justify-content-between align-items-start"
      >
        <div class="w-100">
          <p class="m-0 fw-600 c-body2">{{ info.name }}</p>
          <div class="d-flex align-items-center mt-5">
            <img
              class="mr-5"
              src="@/assets/img/v3/icon/icon_star_1.svg"
              alt=""
            />
            <span class="c-caption mr-5">{{ info.rating }}</span>
            <span class="c-caption">( {{ info.reviews_count }} reviews)</span>
          </div>
          <div class="d-flex align-items-center mt-5">
            <img class="mr-5" :src="bg.icon_address1" alt="" />
            <span class="c-caption lh-20  mr-5">{{ info.location }} </span>
          </div>
        </div>
        <img
          class=""
          style="max-width: 130px;margin:20px auto 0 auto"
          :src="info.logo"
          alt=""
        />
      </div>
      <div class="hr-div mt-20 mb-20"></div>
      <div class="d-flex mt-10 justify-content-between align-items-center">
        <div class="d-flex info-1 align-items-center">
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="golf-ball-tee"
            class="svg-inline--fa fa-golf-ball-tee "
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 384 512"
            width="14"
            height="14"
          >
            <path
              fill="currentColor"
              d="M384 192c0 66.8-34.1 125.6-85.8 160L85.8 352C34.1 317.6 0 258.8 0 192C0 86 86 0 192 0S384 86 384 192zM242.1 256.6c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zm-52.3-49.3c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4c0 18.5-15 33.5-33.5 33.5zm113.5-17.5c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zM96 416c0-17.7 14.3-32 32-32l64 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0c-8.8 0-16 7.2-16 16l0 16c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-16c0-8.8-7.2-16-16-16l-16 0c-17.7 0-32-14.3-32-32z"
            ></path>
          </svg>
          <span class=" ml-5 c-text-p">{{ info.holes_amount }} holes</span>
        </div>
        <div class="d-flex info-1 align-items-center">
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="road"
            class="svg-inline--fa fa-road "
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 576 512"
          >
            <path
              fill="currentColor"
              d="M256 32l-74.8 0c-27.1 0-51.3 17.1-60.3 42.6L3.1 407.2C1.1 413 0 419.2 0 425.4C0 455.5 24.5 480 54.6 480L256 480l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64 201.4 0c30.2 0 54.6-24.5 54.6-54.6c0-6.2-1.1-12.4-3.1-18.2L455.1 74.6C446 49.1 421.9 32 394.8 32L320 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm64 192l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32z"
            ></path>
          </svg>
          <span class=" ml-5 c-text-p"
            >{{ info.course_path?.length }} path</span
          >
        </div>
        <div class="d-flex info-1 align-items-center">
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="location-dot"
            class="svg-inline--fa fa-location-dot "
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 384 512"
            width="14"
            height="14"
          >
            <path
              fill="currentColor"
              d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
            ></path>
          </svg>
          <span class=" ml-5 c-text-p">{{ info.course_length }}</span>
        </div>
        <div class="d-flex info-1 align-items-center">
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="earth-americas"
            class="svg-inline--fa fa-earth-americas "
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            width="14"
            height="14"
          >
            <path
              fill="currentColor"
              d="M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5l0 39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9l0 39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7l0-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1L257 256c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
            ></path>
          </svg>
          <span class=" ml-5 c-text-p">{{ info.country?.name }}</span>
        </div>
      </div>
    </div>
    <div class="info-all-facility info_2">
      <p class="m-0 c-body2 fw-600">{{ $t("introduce") }}:</p>
      <div class="hr-w-70 mt-10 mb-10"></div>
      <p class=" c-caption c-text-p  mt-10">{{ info.description }}</p>
    </div>
    <div class="info-all-facility info_2">
      <p class="m-0 c-body2 fw-600">{{ $t("infoCourse") }}:</p>
      <div class="hr-w-70 mt-20 mb-20"></div>
      <div>
        <p class="mb-10 c-body2 fw-600">{{ $t("wap.text160") }}</p>
        <p class="m-0 c-text-p">{{ $t("wap.text161") }}: {{ info?.name }}</p>
        <p class="m-0 c-text-p">
          {{ $t("wap.text162") }}: {{ info.course_length }}
        </p>
        <p class="m-0 c-text-p">
          {{ $t("wap.text163") }}: {{ info.holes_amount }}
        </p>
        <p class="m-0 c-text-p">
          {{ $t("wap.text164") }}: {{ info.designed_by }}
        </p>
        <p class="m-0 c-text-p">
          {{ $t("wap.text165") }}:
          {{ formatDate(info.opening_date, "DD-MM-YYYY") }}
        </p>
      </div>
      <div class="hr-w-70 mt-20 mb-20"></div>
      <div v-if="info.course_path">
        <p class="c-body2 fw-600 mb-10">{{ $t("wap.text166") }}</p>
        <div v-for="(item, index) in info.course_path" :key="index">
          <div
            style="max-width:450px; padding:10px"
            class="d-flex justify-content-between mb-3 algin-items-center"
            :class="{ 'bg-color-table': index % 2 === 0 }"
          >
            <p class="m-0 c-text-p">
              {{ $t("wap.text166") }} {{ item.path_name }}
            </p>
            <p class="m-0 c-text-p">
              {{ $t("wap.text167") }}: {{ item.num_holes }}
            </p>
            <p class="m-0 c-text-p">
              {{ $t("wap.text168") }}: {{ item.path_par }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getBackGround } from "@/utils/wapAuth";
import { formatDate } from "@/utils/formatData";
export default {
  name: "info-reivew-detail-facility",
  components: {},
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},

  data() {
    return {
      images: [],

      visibleCount: 8,
      bg: getBackGround()
    };
  },
  methods: {
    formatDate
  }
};
</script>

<style></style>

<style scoped lang="scss">
.container-info-facility {
  .info-all-facility {
    margin-bottom: 20px;
    padding: 10px 15px;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
  }
  .info-1 {
    span {
      font-size: 14px;
    }
  }
  .c-text-p {
    color: #4b5563;
  }
  .bg-color-table {
    background-color: #f3f5f6;

    border-radius: 8px;
  }
}
.hr-w-70 {
  width: 70px;
  height: 1px;
  background-color: #e5e7eb;
}
.hr-div {
  height: 1px;
  background-color: #e5e7eb;
}
.title-h3 {
  font-size: 16px;
}
.desktop {
  display: block;
}
.mobile {
  display: none;
}
.text-see-more {
  color: #858585;
  font-size: 12px;
}

@media screen and (min-width: 0px) and (max-width: 769px) {
  .desktop {
    display: none !important;
  }
  .mobile {
    display: block;
  }
  .container-info-facility {
    .info-all-facility {
    }
    .info-1 {
      span {
        font-size: 12px;
      }
    }
  }
}
</style>
